
import { useState, useEffect } from "react";


import input_check from "../input_check.png";
import input_error from "../input_error.png";



function InputNIP(props)
{
 

    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');


    const [onShow,setOnShow] = useState(false);
    

    const validate = (nip) => {
                if(typeof nip !== 'string')
                return false;


            var regExp = /[a-zA-Z]/g;  
            if(regExp.test(nip)){
                    //zawiera jakies litery, np. DE12212
                    return true;  //brak walidacji innych krajów..
            }

            nip = nip.replace(/[\ \-]/gi, '');

            
            nip = nip.replace(/[^0-9.]/g, '');


            if(nip.length == 8) return true; //czeski nip

            if(nip.length != 10) return false;



            let weight = [6, 5, 7, 2, 3, 4, 5, 6, 7];
            let sum = 0;
            let controlNumber = parseInt(nip.substring(9, 10));
            let weightCount = weight.length;
            for (let i = 0; i < weightCount; i++) {
                sum += (parseInt(nip.substr(i, 1)) * weight[i]);
            }
            
            return sum % 11 === controlNumber;
      };


    const checkAndChange = (e) =>
    {
        var v = e.target.value;

        

      //tutux   v = v.replace(/[^0-9]/g, '');       

         

        setVal(v);

        var correct = false;

        if(req == '1' ) 
        {
            if( v.length == 10) correct = true;                               
        }

        else
        {
            if( v.length == 0) correct = true; 
        }

        
        if(v.length > 0)
        {
              correct = validate(v);

    
        }
     
        
               
        
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }

        if(props.valChange != null && props.valChange != undefined)
        {
            props.valChange(props.name, v, correct,'');
        }else
        {
            console.log('No support for valChange');
        }   
        
 
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
               if(props.goNext != null && props.goNext != undefined)
               {
                  props.goNext();
               }
          } 
    }


    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' &&  val != undefined && val != null ) 
        {
            if(val.length != 10 )
            {
                 correct = false;                                       
            }
        }
    

        if( val != null && val.length > 0)
        {
              correct = validate(val);
                console.log("BBBBBB " + correct);
        }

      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }

    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }

    
    useEffect(() => {

        if(val != props.value) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setClassName('');
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })

     

 
    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }


    var cnX = cn;
    if(val != null && val != undefined && val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


    return <fieldset>        
        <input type="text"  value={val} onChange={checkAndChange} onKeyDown={onKeyDown} name={props.name} placeholder={props.placeholder} className={" w150  " + cnX} />        
        {imgx}
        <br/>
             <span className="form_err">{err + " "} &nbsp; </span>        
    </fieldset>
}


export default InputNIP;